export const LOADING_WORKFLOWBLOCKS = 'LOADING_WORKFLOWBLOCKS';
export const LOADING_WORKFLOWBLOCKSM = 'LOADING_WORKFLOWBLOCKSM';
export const LOADING_WORKFLOWBLOCK = 'LOADING_WORKFLOWBLOCK';
export const SAVE_LOADING_WORKFLOWBLOCK = 'SAVE_LOADING_WORKFLOWBLOCK';
export const GET_WORKFLOWBLOCKS = 'GET_WORKFLOWBLOCKS';
export const GET_WORKFLOWBLOCKSM = 'GET_WORKFLOWBLOCKSM';
export const GET_WORKFLOWBLOCK = 'GET_WORKFLOWBLOCK';
export const WORKFLOWBLOCK_FAIL = 'WORKFLOWBLOCK_FAIL';
export const WORKFLOWBLOCK_FAILM = 'WORKFLOWBLOCK_FAILM';
export const WORKFLOWBLOCK_FORM_FAIL = 'WORKFLOWBLOCK_FORM_FAIL';